/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MasterCurrencyItem } from '../../models/master-currency-item';

export interface ApiVendorMasterCurrencyActiveGet$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorMasterCurrencyActiveGet(http: HttpClient, rootUrl: string, params?: ApiVendorMasterCurrencyActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MasterCurrencyItem>>> {
  const rb = new RequestBuilder(rootUrl, apiVendorMasterCurrencyActiveGet.PATH, 'get');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MasterCurrencyItem>>;
    })
  );
}

apiVendorMasterCurrencyActiveGet.PATH = '/api/vendor/master/Currency/Active';
